import {AngularFireDatabase} from '@angular/fire/database';
import {AngularFireStorage} from '@angular/fire/storage';
import {EventEmitter, Injectable} from '@angular/core';
import {UserBoardService} from './user-board.service';
import {Observable} from 'rxjs/Rx';
import DataSnapshot = firebase.database.DataSnapshot;
import {MemberMetaData} from '../_models/_metadata/MemberMetaData';

@Injectable()
export class ReportingService {
  gymId: string;
  private membersMetaArray = [];

  topInterestsEvent = new EventEmitter<Map<string, number>>();
  topGoalsEvent = new EventEmitter<Map<string, number>>();

  readonly SORT_ASC= 'asc';
  readonly SORT_DESC = 'desc';

  constructor(private db: AngularFireDatabase, private storage: AngularFireStorage, private userBoardService: UserBoardService) {
    this.gymId = localStorage.getItem('gym_id');
  }

  loadData() {
    return this.db.database.ref('users').orderByChild('chosenGym').equalTo(this.gymId).on('value', (snapshot) => {
      let arr: MemberMetaData[] = [];
      snapshot.forEach(childSnapshot => {
        arr.push({key: childSnapshot.key, member: childSnapshot.val()});
      });
      this.membersMetaArray = arr;
      this.topInterestsEvent.emit(this.fetchMapSorted(this.fetchAllInterests(), this.SORT_DESC));
      this.topGoalsEvent.emit(this.fetchMapSorted(this.fetchAllGoals(), this.SORT_DESC));
    });
  }


  fetchMapSorted(params: string[], sortType?: string): Map<string, any> {
    let temp = new Map();
    let count = 1;
    let repeated = false;
    params.forEach((param, i, arr) => {
      if(arr[i + 1] === param) {
        count++;
        repeated = true;
        temp.set(param, count);
      } else {
        count = 1;
        if(repeated === false) {
          temp.set(param, count);

        }
      }
    });
    let sorted = new Map(Array.from(temp).sort((a,b) => {
      if(!sortType || sortType === this.SORT_ASC) {
        return a[1] - b[1];
      } else if(sortType === this.SORT_DESC){
        return b[1] - a[1];
      }
    }));

    return sorted;
  }

  private fetchAllInterests() : string[]{
    let interestsArray = [];
    this.membersMetaArray.forEach((x: MemberMetaData) => {
      if(x.member.userInterests){
        x.member.userInterests.forEach((interest: string) => interestsArray.push(interest.toLowerCase()));
      }
    });
    return interestsArray.sort();
  }

  fetchAllGoals() : string[] {
    let goalsArray = [];
    this.membersMetaArray.forEach((x: MemberMetaData) => {
      if(x.member.userGoal) {
        goalsArray.push(x.member.userGoal.toLowerCase());
      }
    });
    return goalsArray.sort();
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/reporting.service.ts